<template>
  <span>
    <div class="loading" :class="{show: loading}"></div>
    <div class="component cart-item" v-if="itemReady" :class="{ thumbnail }">
      <img :src="item.imageUrl" alt="" class="image" v-if="thumbnail">
      <div class="item-info">

        <div v-if="!editable && $parent.$route.name != 'checkout' && $parent.$route.name != 'confirmation'" class="uneditable-message"><span>{{ $t('uneditable.label') }}</span>
          <span v-if="Date.parse(item.date) < Date.now()">{{ $t('uneditable.past-date') }}</span>
          <span v-else>{{ $t('uneditable.too-close') }}</span>
        </div>

        <div class="name-container">
          <div class="name">{{ itemName }}</div>
          <div class="edit-buttons" v-if="editable">

            <router-link :to="{ name: item.type, params: {id: item.itemId}, query: {editing: item.id} }" v-if="item.type !== 'product'  && itemReady.activityType !== 'p2p'">{{ $t('general.label.edit') }}</router-link>
            <a class="delete" @click="onDeleteItem"></a>
          </div>
        </div>

        <activity-cart-item :item="item" v-if="item.type === 'activity'" :editable="editable" />
        <package-cart-item :item="item" v-if="item.type === 'package'" :editable="editable" />
        <product-cart-item :item="item" v-if="item.type === 'product'" :editable="editable" />
        <gift-certificate-cart-item :item="item" v-if="item.type === 'giftcert'" :editable="editable"/>
      </div>
    </div>
  </span>
</template>

<script>
import Cart from '@/models/Cart';
import ActivityCartItem from '@/components/ActivityCartItem.vue';
import ProductCartItem from '@/components/ProductCartItem.vue';
import PackageCartItem from '@/components/PackageCartItem.vue';
import GiftCertificateCartItem from '@/components/GiftCertificateCartItem.vue';

export default {
  props: {
    item: Object,
    thumbnail: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false
    }
  },

  computed: {
    itemReady() {
      return this.item.type === 'giftcert' || this.item.details;
    },

    itemName() {
      return this.item.type === 'giftcert' ? this.$t('Gift Certificate') : this.item.details.name;
    }
  },

  methods: {
    onDeleteItem() {
      if(window.confirm(`Remove "${this.itemName}" from your cart?`))
        this.loading = true;
        Cart.remove(this.item).then(() => {this.loading = false;});
    },

  },

  components: {
    ActivityCartItem,
    ProductCartItem,
    PackageCartItem,
    GiftCertificateCartItem
  }
}
</script>

<style lang="scss">
.component.cart-item {
  &:not(:last-child) {
    border-bottom: 1px solid $colorPaleGray;
  }
  padding: 10px 15px 0 15px;
  margin-top: 10px;
  margin-bottom: 10px;

  &.thumbnail {
    display: grid;
    display: -ms-grid;
    grid-template-columns: auto 1fr;
    -ms-grid-columns: auto 1fr;
    grid-gap: 10px;

    @include breakpoint(medium) {
      grid-gap: 20px;
    }

    .image {
      object-fit: cover;
      width: 60px;
      height: 60px;
      -ms-grid-column: 1;
      @include breakpoint(medium) {
        height: 80px;
        width: 80px;
      }

      /*  Edge */
      @supports (-ms-ime-align:auto) {
        margin-right: 20px;
      }
      /*  IE */
      @media all and (-ms-high-contrast:none) {
        margin-right: 20px;
      }
    }
  }

  .item-info {
    -ms-grid-column: 2;
  }

  .uneditable-message {
    font-size: 12px;
    line-height: 16px;
    color: $colorYellow;
    margin-bottom: 5px;

    span {
      @include badge($colorYellow);
      margin: 0 5px 0 0;
    }
  }

  .name-container {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 5px;
  }

  .name {
    @include font-h2;
  }

  .edit-buttons {
    text-align: right;
    padding: 3px;

    > a:not(:first-child):last-child::before {
      content: "|";
      color: $colorPaleGray;
      margin: 0 10px;
    }

    .delete {
      display: inline-flex;
      align-items: center;
      color: $colorGray;

      &:hover {
        color: $colorRed;
      }

      &::after {
        @include font-awesome-pseudo($fa-var-times, light);
        font-size: 18px;
      }
    }
  }

  .details {
    margin: 8px 0 0 0;

    dt {
      float: left;
      color: $colorGray;
      margin-right: 10px;
    }
    dd {
      margin: 0;
    }
  }

  .prices {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 10px;

    .price-breakdown {
      @include unlisted;
      margin-right: 10px;
    }

    .subtotal {
      @include font-h2;
    }
  }

  .options-label {
    margin-left: 20px;
  }

  .date {
    display: inline-block;
    background-color: #ddd;
    padding: 2px 10px;
    margin-top: 5px;
  }

   // For P2P
  .p2p {
    .from::after {
      @include font-awesome-pseudo($fa-var-long-arrow-alt-right, regular);
      color: $colorOrange;
      margin: 0 5px;
    }
  }
}
</style>